<ion-header>
  <app-navheader [page]="isLogin()"></app-navheader>
  <img src="../../../../assets/img/black-arrow-login.png" class="black-arrow-login"/>
</ion-header>
<ion-content padding style="background-color: #04c4fc">
  <ion-item lines="none" class="header blue-item">
    <ion-label>
      <h1 class="h1-blue-page">
        {{'ACCOUNT_CREATION.CREER_PROFILS' |translate}}
      </h1>
    </ion-label>
  </ion-item>
  <ion-item lines="none" class="blue-item">
    <ion-label>
      <div class="profiletypewrapper clear">
        <div [ngClass] = "{'choose-profile': true, 'active': isParentActive}" (click) = "isParentActive = true; isEnseignantActive = false">{{'ACCOUNT_CREATION.PARENT' | translate}}</div>
        <div [ngClass] = "{'choose-profile-right': true, 'active': isEnseignantActive}" (click)="isEnseignantActive = true; isParentActive = false">{{'ACCOUNT_CREATION.ENSEIGNANT' | translate}}</div>
      </div>
    </ion-label>
  </ion-item>
  <div class="wrapper">
    <ion-list>
      <form>
        <ion-item lines="none" class="firstinput blue-item" [hidden] = "isParentActive">
            <ion-label position="stacked">{{'ACCOUNT_CREATION.LABELS.NOM_ESTABLISMENT' | translate}}</ion-label>
            <ion-input [(ngModel)]="model.schoolName" name="schoolName" [ngClass] = "{'ng-invalid': !schoolName.valid, 'ng-dirty': !schoolName.pristine}" type="text" #schoolName = "ngModel"></ion-input>
        </ion-item>
        <div class="errortextpassword" [hidden]= "schoolName.valid || schoolName.pristine || isParentActive">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>

        <ion-item lines="none" class="blue-item">
          <ion-label position="stacked">{{'ACCOUNT_CREATION.LABELS.PRENOM' | translate}} <span *ngIf="!isParentActive">{{'ACCOUNT_CREATION.DE_ENSEIGNANT' | translate}}</span></ion-label>
          <ion-input required [(ngModel)]="model.firstName" name="firstName" [ngClass] = "{'ng-invalid': !firstName.valid, 'ng-dirty': !firstName.pristine}" type="text" #firstName = "ngModel"></ion-input>
        </ion-item>
        <div class="errortext" [ngClass]= "{'visible': error}">{{error}}</div>
        <div class="errortextpassword" [hidden]= "firstName.valid || firstName.pristine">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>

        <ion-item lines="none" class="firstinput blue-item">
          <ion-label position="stacked">{{'ACCOUNT_CREATION.LABELS.NOM' | translate}} <span *ngIf="!isParentActive">{{'ACCOUNT_CREATION.DE_ENSEIGNANT' | translate}}</span></ion-label>
          <ion-input required [(ngModel)]="model.lastName" name="lastName"  [ngClass] = "{'ng-invalid': !lastName.valid, 'ng-dirty': !lastName.pristine}" type="text" #lastName = "ngModel"></ion-input>
        </ion-item>
        <div class="errortext" [ngClass]= "{'visible': error}">{{error}}</div>
        <div class="errortextpassword" [hidden]= "lastName.valid || lastName.pristine">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>

        <ion-item lines="none" class="profile-password blue-item" hidden>
          <ion-label position="stacked" [innerHTML] = "'ACCOUNT_CREATION.LABELS.MOT_DE_PASSE_PARENT' | translate"></ion-label>
          <ion-input [(ngModel)]="model.password" [ngClass] = "{'ng-invalid': error, 'ng-dirty': error}" [type] = "show.value ? 'text' : 'password'" name="password" #password = "ngModel"></ion-input>
        </ion-item>
        <div class="qmarkwrapper" hidden>
          <img (click)="presentPopover($event)" class="qmark" src="../../../assets/img/qmark.png" />
        </div>
        <div class="errortext" [ngClass]= "{'visible': error}" [hidden] = "!isParentActive">{{error}}</div>
        <div class="errortextpassword" [hidden]= "password.valid || password.pristine || !isParentActive">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>

        <!--  Pour profil ensegnant -->
        <ion-item lines="none" class="firstinput blue-item" [hidden] = "isParentActive">
          <ion-label position="stacked">{{'ACCOUNT_CREATION.LABELS.VOTRE_NUMERO_ABONNEMENT' | translate}}</ion-label>
          <ion-input [disabled] = "isParentActive" required [(ngModel)]="model.subscriber_number" [ngClass] = "{'ng-invalid': error, 'ng-dirty': error}" name="subscriber_number" #subscriber_number = "ngModel"></ion-input>
        </ion-item>
        <div class="qmarkwrapper" [hidden] = "isParentActive">
          <img (click)="presentPopover2($event)" class="qmark2" src="../../../assets/img/qmark.png" />
        </div>
        <ng-container *ngIf="!isParentActive">
          <div class="errortext" [ngClass]= "{'visible': error}">{{error}}</div>
          <div class="errortextpassword" [hidden]= "subscriber_number.valid || subscriber_number.pristine">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>
        </ng-container>
        <ion-item lines="none" class="abonumber blue-item" [hidden] = "isParentActive">
          <ion-label position="stacked">{{'ACCOUNT.PROFILE_CREATOR.COUPON' | translate}}</ion-label>
          <ion-input (ionChange) = "changeHandler()" [(ngModel)]="model.coupon" [ngClass] = "{'invalid': error_coupon, 'dirty': error_coupon}" type = "text" name="coupon" #coupon = "ngModel"></ion-input>
        </ion-item>
        <div class="qmarkwrapper" [hidden] = "isParentActive">
          <img (click)="presentPopover3($event)" class="qmark3" src="../../../assets/img/qmark.png" />
        </div>
        <!-- <div class="errortext" [ngClass]= "{'visible': error_coupon}">{{error_coupon}}</div> -->
        <ion-item lines="none" class="errortext" [hidden] = "isParentActive" [ngClass]= "{'visible': error_coupon, 'hidden':  coupon.valid}">{{'ERROR.COUPON.INVALID_CODE' | translate}}</ion-item>
        <!-- <div class="aide-dev" (click) = "showTempPopUp()" [hidden] = "isParentActive">Cliquer ici pour les codes d'accès gratuits</div> -->
        <!--  Pour profil ensegnant -->

        <ion-item lines="none" class="blue-item" hidden>
          <ion-label>{{'ACCOUNT_CREATION.LABELS.AFFICHER_MOT_DE_PASSE' | translate}}</ion-label>
          <ion-checkbox color="white" class="show" name="show" checked="true" [(ngModel)] = "model.show" #show= "ngModel"></ion-checkbox>
        </ion-item>

        <ion-item lines="none" class="firstinput blue-item" hidden>
          <ion-label position="stacked">{{'ACCOUNT_CREATION.LABELS.CONFIRMER_MOT_DE_PASSE' | translate}}</ion-label>
          <ion-input (ionBlur)="checkOnBlur()" required [(ngModel)]="model.password2" name= "password2"  [ngClass] = "{'ng-invalid': error, 'ng-dirty': error, 'emailvalidation': !validation && userstatus}" [type] = "show.value ? 'text' : 'password'" #password2 = "ngModel"></ion-input>
        </ion-item>
        <div [hidden] = "!isParentActive" class="errortext" [ngClass]= "{'visible': error}">{{error}}</div>
        <div [hidden] = "!isParentActive" class="errortext" [ngClass]= "{'visible': !validation && userstatus}">{{'ERROR.RESET_PASSWORD.PASSWORD_REPEAT' | translate}}</div>
        <div [hidden] = "password2.valid || password2.pristine || !isParentActive" class="errortextpassword">{{'ERROR.LOGIN.REQUIRED' | translate}}</div>
        <button class="connect button" [disabled]="!firstName.valid || !lastName.valid || !password.valid || password.value !== password2.value" [hidden] = "!isParentActive" (click)="createProfile('Parent');">
          <img class="nextstep" src="../../../assets/img/next-step-icon.png">
          <div class="next">{{ 'ACCOUNT_CREATION.ETAPE_SUIVANTE' | translate }}</div>
          <div class="ion-text-left">{{ 'ACCOUNT_CREATION.CREER_PROFILS' | translate }}</div>
        </button>
        <ion-button class="createTeacherProfileAction" [disabled]="!firstName.valid || !lastName.valid || !schoolName.valid" [hidden]="isParentActive" (click)="createProfile('Teacher');">
          {{'ACCOUNT_CREATION.VALIDER' | translate}}
        </ion-button>
      </form>
    </ion-list>
  </div>
</ion-content>
<ion-footer>
  <app-bottom-menu></app-bottom-menu>
</ion-footer>
<app-pop-up [show] = "tempPopUp" [data] = "popup" (popUpNotify)="onNotifyPopUp($event)" #temppopup></app-pop-up>

